import { getTotalCosts } from "./basket-selectors"
import { getExtrasForSelectedPhone } from "./extras-selector"
import { getExtras } from "containers/pages/pick-summaries/pick-data-functions"

export const getTotalMonthlySpend = state => {
  const totalCosts = getTotalCosts(state)

  return totalCosts && totalCosts.maf
}

export const getTotalHandsetSpend = state => {
  const totalCosts = getTotalCosts(state)

  return totalCosts && totalCosts.handset
}

export const getTotalAirtimeSpend = state => {
  const totalCosts = getTotalCosts(state)

  return totalCosts && totalCosts.airtime
}

export const getTotalUpfrontSpend = state => {
  const totalCosts = getTotalCosts(state)

  return totalCosts && totalCosts.upfront
}

export const getTotalExtrasSpend = state => {
  // Go through all the extras in the basket
  // and iterate up all the costs

  // First get the extras for this device and plan
  const possibleExtras = getExtrasForSelectedPhone(state)

  // then add up the costs
  return (
    possibleExtras &&
    state.basket.extras.reduce(
      (total, extraID) => total + possibleExtras[extraID].cost,
      0
    )
  )
}

export const getDataAmount = state => {
  const { planID } = state.basket
  return planID && state.plans.byID[planID].data.data
}

export const getMonthsAmount = state => {
  const { planID } = state.basket
  return planID && state.plans.byID[planID].data.contractLength
}

export const getTextsAmount = state => {
  const { planID } = state.basket
  return planID && state.plans.byID[planID].data.texts
}

export const getMinutesAmount = state => {
  const { planID } = state.basket
  return planID && state.plans.byID[planID].data.minutes
}

export const getNetworkAmount = state => {
  const { planID } = state.basket
  return planID && state.plans.byID[planID].data.network
}

export const isUnlimitedData = state => {
  const { planID } = state.basket
  const dataAmount = planID && state.plans.byID[planID].data.data

  return dataAmount && dataAmount.search(/unlimited/gi) >= 0
}

export const was5GPicked = state => {
  const { planID } = state.basket
  return planID && state.plans.byID[planID].data.network === "5G"
}

export const wasEntertainmentSelected = state => {
  const { planID, entertainment } = state.basket
  return entertainment[planID] === 6 ? "1" : "0"
}

export const getExtrasText = (extras, phoneID, planID, state) => {
  if (extras) {
    let allExtras = getExtras(phoneID, planID, extras)(state)
    let extrasText = allExtras.map(extra => extra.shortText)
    return extrasText
  } else {
    return ""
  }
}

export const getBenefitsText = (benefits, state) => {
  if (benefits) {
    let benefitsText = benefits.map(benefitID => {
      return state.benefits.byID[benefitID].shortText
    })
    return benefitsText
  } else {
    return ""
  }
}
